import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { role } from '@components/frame';
import { ROLES } from '@helpers';
import { getDevices } from '@reducers/device';
import { OPERATOR_RESTRICTIONS } from '@config/operatorRestrictions';
import { useAppDispatch } from '@store/hooks/useAppDispatch';
import { RootState } from '@store/types';
import { UseFetchDevicesOptions, UserInfo } from '@interfaces/devices';

export const useFetchDevicesFiltered = (options: UseFetchDevicesOptions = {}) => {
  const dispatch = useAppDispatch();
  const { devices, loaded, isDeviceMore } = useSelector((state: RootState) => state.device);
  const userInfo = useSelector((state: RootState) => state.user.userInfo) as UserInfo;

  useEffect(() => {
    const isOperator = role === ROLES.OPERATOR;
    const shouldFilterByUser = isOperator && OPERATOR_RESTRICTIONS.devicesOwnOnly;

    if (shouldFilterByUser && userInfo?.emailAddress) {
      dispatch(
        getDevices({
          reset: true,
          ...options,
          filters: { lastUsedBy: { value: userInfo.emailAddress, valueType: 'string' } },
        })
      );
    } else {
      dispatch(getDevices({ reset: true, ...options }));
    }
  }, [userInfo?.emailAddress]);

  return { devices, loaded, isDeviceMore };
};
